import {
    useState
} from "react";

import {
    useNavigate
} from "react-router-dom";

import API from "../../services/api";
import toast from "react-hot-toast";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function AdminLogin() {

    const navigate = useNavigate();

    const [phone, setPhone] = useState("");

    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const login = async () => {
        try {
            const res = await API.post("/admin/login", {
                phone,
                password,
            });

            localStorage.setItem(
                "adminToken",
                res.data.token
            );

            localStorage.setItem(
                "admin",
                JSON.stringify(res.data.admin)
            );

            localStorage.setItem(
                "permissions",
                JSON.stringify(
                    res.data.permissions
                )
            );

            navigate("/admin/dashboard");
        } catch (err) {
            console.log(err.response?.data);
            toast.error("Invalid Login");
        }
    };

    return (
        <div
            className="
      min-h-screen
      flex
      items-center
      justify-center
      bg-black
      "
        >

            <div
                className="
        bg-[#111]
        p-8
        rounded-3xl
        w-full
        max-w-md
        "
            >

                <h1
                    className="
          text-3xl
          text-yellow-400
          font-bold
          mb-6
          "
                >
                    Login
                </h1>

                <input
                    placeholder="Phone"
                    value={phone}
                    onChange={(e) =>
                        setPhone(
                            e.target.value
                        )
                    }
                    className="
          w-full
          p-4
          mb-4
          bg-black
          rounded-xl
          "
                />

                <div className="relative mb-4">
                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="
            w-full
            p-4
            pr-12
            bg-black
            rounded-xl
        "
                    />

                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="
            absolute
            right-4
            top-1/2
            -translate-y-1/2
            text-gray-400
            hover:text-yellow-400
        "
                    >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                </div>

                <button
                    onClick={login}
                    className="
          w-full
          p-4
          rounded-xl
          bg-yellow-500
          text-black
          font-bold
          "
                >
                    Login
                </button>

            </div>

        </div>
    );
}

export default AdminLogin;